<script>
export default {
  name: "CheatingConfirmModal",
  data(){
    return{
      loading:false
    }
  },
  methods: {
    cancelModal() {
      this.$bvModal.hide("Modal-Confirmed-Plagiarism")
    },
    submit() {
      this.$emit('markZeroPoint')
      this.$bvModal.hide("Modal-Confirmed-Plagiarism");
    }
  }
}
</script>

<template>
  <div>
    <b-modal id="Modal-Confirmed-Plagiarism" centered title="Xác nhận bài thi đạo văn từ 50% trở lên" hide-footer
             :no-close-on-backdrop="true" hide-header-close >
      <p class="">Khi chọn tỉ lệ đạo văn từ 50% trở lên, hệ thống sẽ tự động chấm bài <span style="color: red">0 điểm</span></p>
      <p style="font-weight: bold">Bạn có chắc chắn muốn tiếp tục?</p>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary mr-4" @click="cancelModal()">Hủy bỏ</button>
        <button type="button" class="btn btn-info" @click="submit()" ><i class="el-icon-loading" v-if="loading"></i> Xác nhận</button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>

</style>